import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFacebookF as faFacebook,
    faXTwitter as faXTwitter,
    faInstagram,
    faLinkedinIn as faLinkedin
} from '@fortawesome/free-brands-svg-icons';
import React from 'react';

const ItemsList = [
    { icon: faFacebook, link: "https://facebook.com" },
    { icon: faXTwitter, link: "https://x.com" },
    { icon: faInstagram, link: "https://instagram.com" },
    { icon: faLinkedin, link: "https://linkedin.com" }
];

const FooterHeader = ({ logo, textColor = 'text-white', borderColor = 'border-white/20' }) => {
    return (
        <div className={`flex flex-col md:flex-row justify-between items-center gap-4 md:gap-8 pb-8 md:pb-12 border-b ${borderColor}`}>
            {/* Logo */}
            <div className="mb-4 md:mb-0">
                <img
                    src={logo}
                    alt="Logo"
                    className="h-10 md:h-12 w-auto max-w-[160px]"
                />
            </div>

            {/* Social icons */}
            <div className={`flex flex-col md:flex-row items-center gap-3 md:gap-6 w-full md:w-auto ${textColor}`}>
                <p className="text-sm md:text-base whitespace-nowrap">Follow us</p>
                <div className="flex justify-center gap-3 md:gap-5">
                    {ItemsList.map((item) => (
                        <a
                            key={item.link}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`flex items-center justify-center w-10 h-10 rounded-xl bg-blue-1 ${textColor} text-lg hover:opacity-80 transition`}
                        >
                            <FontAwesomeIcon icon={item.icon} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FooterHeader;
